export const baseUrl = "http://111.118.187.246/api/api/v1/"; // new staging url
// export const baseUrl = "http://111.118.189.135/dccc/api/v1/"; // old staging url but current prod
// export const baseUrl = "https://ncd-staging.mohfw.gov.in/dccc/api/v1/"; //prod url
// export const baseUrl = "http://172.16.2.164:4200/api/v1/";  
// export const baseUrl = "/dccc/api/v1/";

export const aesKey = "LQ8yCTiDOFQFk8FFo1CpftkBoBnEIJmu";
export const aesIv = "213A26DBB4A358C5";
export const ENCRYPTION_ALGORITHM = "aes - 256 - cbc"